module.exports = __webpack_public_path__ + "static/WF2-15e10d5a49def304b7dc0b823ffa33ba.png";